import { render, staticRenderFns } from "./ReadyModal.vue?vue&type=template&id=16b8ed98"
import script from "./ReadyModal.vue?vue&type=script&lang=js"
export * from "./ReadyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports